import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ShieldCheck, ArrowLeft, FileText } from "lucide-react";

// Render markdown mínimo: **negrita**, líneas de lista "- ", y párrafos.
function MarkdownLite({ text }) {
  const bloques = text.split("\n").filter((l) => l.trim() !== "");
  const inline = (s) =>
    s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
      part.startsWith("**") && part.endsWith("**")
        ? <strong key={i} className="text-[#0E2A47]">{part.slice(2, -2)}</strong>
        : <span key={i}>{part}</span>
    );
  return (
    <div className="space-y-3 text-sm leading-relaxed text-[#0E2A47]/80">
      {bloques.map((b, i) =>
        b.trim().startsWith("- ")
          ? <div key={i} className="flex gap-2 pl-2"><span className="text-[#FF5625]">•</span><span>{inline(b.trim().slice(2))}</span></div>
          : <p key={i}>{inline(b)}</p>
      )}
    </div>
  );
}

export default function Legal() {
  const { clave } = useParams();
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    api.get(`/legal/${clave}`).then((r) => setData(r.data)).catch(() => setData({ disponible: false })).finally(() => setLoaded(true));
  }, [clave]);

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      <header className="bg-[#0E2A47] text-white">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ShieldCheck className="text-[#FF5625]" size={24} />
            <span className="font-black text-lg tracking-tighter">AuditReady<span className="text-[#FF5625]">.</span></span>
          </div>
          <Link to="/login" className="text-sm text-white/70 hover:text-white flex items-center gap-1" data-testid="legal-volver"><ArrowLeft size={15} />Volver</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10" data-testid={`legal-page-${clave}`}>
        {!loaded ? (
          <div className="text-[#0E2A47]/40 text-sm">Cargando…</div>
        ) : data?.disponible ? (
          <>
            <h1 className="text-2xl sm:text-3xl font-black tracking-tighter text-[#0E2A47]" data-testid="legal-titulo">{data.titulo}</h1>
            <div className="text-xs text-[#0E2A47]/40 mt-1 mb-6">
              Versión {data.version}{data.fecha_publicacion ? ` · publicada ${new Date(data.fecha_publicacion).toLocaleDateString("es-ES")}` : ""}
            </div>
            <MarkdownLite text={data.contenido} />
          </>
        ) : (
          <div className="text-center py-20" data-testid="legal-proximamente">
            <FileText size={40} className="mx-auto text-[#0E2A47]/20 mb-4" />
            <div className="text-lg font-bold text-[#0E2A47]">Disponible próximamente</div>
            <p className="text-sm text-[#0E2A47]/50 mt-2">Este documento estará publicado en breve.</p>
          </div>
        )}
      </main>
    </div>
  );
}
